var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import QS from "qs";
import jsonp from "jsonp";
const host = [
    "m.chelun.com",
    "m1.chelun.com",
    "m2.chelun.com",
    "m3.chelun.com",
    "m4.chelun.com",
    "h5.chelun.com"
].indexOf(window.location.host) >= 0
    ? "//passport.chelun.com"
    : "//passport-test.chelun.com";
function fetchData(path, data = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        let fetchUrl = host + path;
        fetchUrl +=
            "?" +
                QS.stringify({
                    os: "h5",
                    __c: Date.now()
                });
        const raw = yield fetch(fetchUrl, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
            },
            body: QS.stringify(data)
        });
        return yield raw.json();
    });
}
/**
 * 获取短信验证码
 * @param mobile 手机号
 * @param imageCodeInfo 图形验证码相关信息
 */
export function getSmsCode(mobile, imageCodeInfo = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        return fetchData("/api_v2/get_sms_captcha", Object.assign({ phone: mobile }, imageCodeInfo));
    });
}
/**
 * 以手机号和短信验证码登录
 * @param mobile
 * @param code
 * @param imageCodeInfo
 */
export function loginWithSmsCode(mobile, code, imageCodeInfo = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        return fetchData("/api_v2/login_with_captcha", Object.assign({ phone: mobile, captcha: code }, imageCodeInfo));
    });
}
/**
 * 获取图形验证码相关信息
 */
export function getImageCodeCookie() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            jsonp(host + `/api/get_cookie`, {
                param: "getCookie"
            }, (error, data) => {
                if (error != null) {
                    reject(error);
                }
                else {
                    resolve(data);
                }
            });
        });
    });
}
